import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { bytes } from "@/features/library/format";
import { FileName } from "./FileName";
import { useWorkspaceFiles } from "./useFiles";
import type { FileRow } from "./types";

/** Pick an existing file from the workspace Files area. */
export function FilePickerDialog(props: { workspaceId: string; excludeIds: string[]; onOpenChange(open: boolean): void; onPick(file: FileRow): void }) {
  const files = useWorkspaceFiles(props.workspaceId);
  const [q, setQ] = useState("");
  const needle = q.toLowerCase().trim();
  const items = (files.data?.files ?? [])
    .filter((f) => !props.excludeIds.includes(f.id))
    .filter((f) => !needle || `${f.filename} ${f.description ?? ""}`.toLowerCase().includes(needle))
    .slice(0, 100);
  return (
    <Dialog open onOpenChange={props.onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Link an existing file</DialogTitle>
          <DialogDescription>Files uploaded anywhere in this notebook or project.</DialogDescription>
        </DialogHeader>
        <Input autoFocus placeholder="Filter files…" aria-label="Filter files" value={q} onChange={(e) => setQ(e.target.value)} className="h-8" />
        <ul className="max-h-72 space-y-0.5 overflow-y-auto rounded-md border p-1" aria-label="Files in this notebook or project">
          {items.map((f) => (
            <li key={f.id}>
              <button type="button" onClick={() => props.onPick(f)} className="flex w-full items-center gap-2 rounded px-2 py-1 text-left text-sm hover:bg-accent">
                <FileName file={f} className="min-w-0 flex-1" />
                <span className="shrink-0 text-xs text-muted-foreground">{bytes(f.sizeBytes)}</span>
              </button>
            </li>
          ))}
          {files.data && !items.length && <li className="px-2 py-1 text-sm text-muted-foreground">No other files in this notebook or project.</li>}
          {files.isLoading && <li className="px-2 py-1 text-sm text-muted-foreground">Loading…</li>}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
